export default __webpack_public_path__ + "b915e241582911987b956ba1dfc5366d.png";